/*
 * Solorent – Tracciamento provenienza dei lead
 * ------------------------------------------------------------------
 * Salva, per ogni visitatore, il PRIMO e l'ULTIMO contatto con il sito:
 * sorgente, mezzo, campagna, parola chiave, gclid / gbraid / wbraid,
 * msclkid, fbclid, pagina di atterraggio e referrer.
 *
 * Consenso: legge l'API Shopify Customer Privacy (alimentata dal banner
 * Pandectes).
 *   - consenso marketing dato  -> localStorage, scadenza SR_ATTR_DAYS giorni
 *   - consenso non dato/revocato -> i dati nel localStorage vengono cancellati e
 *     il comportamento è definito da
 *     window.SR_CONFIG.attributionWithoutConsent:
 *       'session' (default): sessionStorage, si cancella alla chiusura della scheda
 *       'none'             : nessun salvataggio
 *   Se il consenso arriva dopo, i dati di sessione vengono spostati
 *   nel localStorage.
 *
 * API pubblica: window.SRAttribution.get() -> { primo, ultimo, consenso_marketing }
 */
(function () {
  'use strict';
  if (window.__srAttrLoaded) return; // una sola cattura per caricamento completo della pagina
  window.__srAttrLoaded = true;

  var KEY = 'sr_attr_v1';
  var SR_ATTR_DAYS = 90;
  var CLICK_IDS = ['gclid', 'gbraid', 'wbraid', 'msclkid', 'fbclid'];
  var UTMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  var SEARCH_ENGINES = [
    { re: /(^|\.)google\./, name: 'google' },
    { re: /(^|\.)bing\.com$/, name: 'bing' },
    { re: /(^|\.)yahoo\./, name: 'yahoo' },
    { re: /(^|\.)duckduckgo\.com$/, name: 'duckduckgo' },
    { re: /(^|\.)ecosia\.org$/, name: 'ecosia' },
    { re: /(^|\.)libero\.it$/, name: 'libero' }
  ];
  var MAX = 255;

  function cfg() { return window.SR_CONFIG || {}; }
  function cut(v) { return v == null ? '' : String(v).slice(0, MAX); }

  /* ---------- consenso ---------- */
  // 'yes' | 'no' | 'unknown' (API non ancora caricata)
  function consentState() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.marketingAllowed === 'function') return cp.marketingAllowed() ? 'yes' : 'no';
    } catch (e) { /* ignore */ }
    return 'unknown';
  }
  function marketingAllowed() { return consentState() === 'yes'; }

  /* ---------- storage sicuro ---------- */
  function store(type) {
    try {
      var s = window[type];
      var t = '__sr_t';
      s.setItem(t, '1'); s.removeItem(t);
      return s;
    } catch (e) { return null; }
  }
  function readFrom(s) {
    if (!s) return null;
    try {
      var raw = s.getItem(KEY);
      if (!raw) return null;
      var d = JSON.parse(raw);
      if (d && d.exp && Date.now() > d.exp) { s.removeItem(KEY); return null; }
      return d;
    } catch (e) { return null; }
  }
  // restituisce il dato più recente tra localStorage e sessionStorage
  function read() {
    var a = readFrom(store('localStorage'));
    var b = readFrom(store('sessionStorage'));
    if (a && b) return (b.upd || 0) > (a.upd || 0) ? b : a;
    return a || b;
  }
  function write(data) {
    var state = consentState();
    var mode = cfg().attributionWithoutConsent || 'session';
    var ls = store('localStorage');
    var ss = store('sessionStorage');
    data.upd = Date.now();
    try {
      if (state === 'yes') {
        data.exp = Date.now() + SR_ATTR_DAYS * 864e5;
        if (ls) ls.setItem(KEY, JSON.stringify(data));
        if (ss) ss.removeItem(KEY);
      } else if (state === 'no') {
        delete data.exp;
        if (ls) ls.removeItem(KEY); // consenso non dato o revocato
        if (mode === 'session' && ss) ss.setItem(KEY, JSON.stringify(data));
        else if (ss) ss.removeItem(KEY);
      } else {
        // consenso ancora sconosciuto: solo sessione, senza cancellare dati già salvati
        delete data.exp;
        if (mode === 'session' && ss) ss.setItem(KEY, JSON.stringify(data));
      }
    } catch (e) { /* quota o storage bloccato: si prosegue senza */ }
  }

  // quando l'API del consenso diventa disponibile, sistema dove sono salvati i dati
  function settle(attempt) {
    if (consentState() !== 'unknown') {
      var d = read(); if (d) write(d);
      return;
    }
    if ((attempt || 0) < 20) setTimeout(function () { settle((attempt || 0) + 1); }, 500);
  }

  /* ---------- lettura della visita corrente ---------- */
  function hostOf(url) {
    try { return new URL(url).hostname.toLowerCase(); } catch (e) { return ''; }
  }
  function sameSite(host) {
    var here = location.hostname.toLowerCase().replace(/^www\./, '');
    var h = host.replace(/^www\./, '');
    return h === here || /\.myshopify\.com$/.test(h) || /(^|\.)shopify\.com$/.test(h);
  }

  function currentTouch() {
    var p;
    try { p = new URLSearchParams(location.search); } catch (e) { return null; }
    var t = {};
    UTMS.concat(CLICK_IDS).forEach(function (k) {
      var v = p.get(k);
      if (v) t[k] = cut(v);
    });
    var ref = document.referrer || '';
    var refHost = hostOf(ref);
    var external = refHost && !sameSite(refHost);
    var hasParams = Object.keys(t).length > 0;

    if (!hasParams && !external) return null; // navigazione interna o diretta: nessun nuovo contatto

    var fonte, mezzo;
    if (t.utm_source) {
      fonte = t.utm_source; mezzo = t.utm_medium || '';
    } else if (t.gclid || t.gbraid || t.wbraid) {
      fonte = 'google'; mezzo = 'cpc';
    } else if (t.msclkid) {
      fonte = 'bing'; mezzo = 'cpc';
    } else if (t.fbclid) {
      fonte = 'facebook'; mezzo = 'social';
    } else if (external) {
      var se = SEARCH_ENGINES.filter(function (s) { return s.re.test(refHost); })[0];
      if (se) { fonte = se.name; mezzo = 'organic'; }
      else { fonte = refHost.replace(/^www\./, ''); mezzo = 'referral'; }
    }

    return {
      fonte: cut(fonte),
      mezzo: cut(mezzo),
      campagna: t.utm_campaign || '',
      termine: t.utm_term || '',
      contenuto: t.utm_content || '',
      gclid: t.gclid || '',
      gbraid: t.gbraid || '',
      wbraid: t.wbraid || '',
      msclkid: t.msclkid || '',
      fbclid: t.fbclid || '',
      landing: cut(location.origin + location.pathname + location.search),
      referrer: cut(ref),
      ts: new Date().toISOString()
    };
  }

  function directTouch() {
    return {
      fonte: '(direct)', mezzo: '(none)', campagna: '', termine: '', contenuto: '',
      gclid: '', gbraid: '', wbraid: '', msclkid: '', fbclid: '',
      landing: cut(location.origin + location.pathname + location.search),
      referrer: '', ts: new Date().toISOString()
    };
  }

  /* ---------- cattura: una sola volta per caricamento completo ----------
   * Con InstantClick le pagine successive non ricaricano questo script,
   * quindi la cattura avviene solo all'arrivo sul sito. */
  function capture() {
    var data = read() || {};
    var touch = currentTouch();
    if (!data.primo) data.primo = touch || directTouch();
    if (touch) data.ultimo = touch;
    if (!data.ultimo) data.ultimo = data.primo;
    write(data);
  }

  try { capture(); settle(0); } catch (e) { /* mai bloccare la pagina */ }

  /* se il visitatore accetta i cookie dopo l'arrivo, sposta i dati nel localStorage */
  document.addEventListener('visitorConsentCollected', function () {
    try { var d = read(); if (d) write(d); } catch (e) { /* ignore */ }
  });

  window.SRAttribution = {
    get: function () {
      var d = read() || {};
      return {
        primo: d.primo || null,
        ultimo: d.ultimo || null,
        consenso_marketing: marketingAllowed()
      };
    }
  };
})();
